import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '../../app-config.module';
import { HandshakeService } from '@challenger/care/services/handshake.service';

export enum IdentifyCustomerByAddressResponse {
  NO_RESULT = 'NO_RESULT',
  ONE_RESULT = 'ONE_RESULT',
  MULTIPLE_RESULTS = 'MULTIPLE_RESULTS',
  VERIFIED_ACCOUNT = 'VERIFIED_ACCOUNT',
  UNVERIFIED_ACCOUNT = 'UNVERIFIED_ACCOUNT',
  ACCOUNT_CLOSED = 'ACCOUNT_CLOSED',
  UNIQUE_FOUND = 'UNIQUE_FOUND',
  POSTCODE_INVALID = 'POSTCODE_INVALID',
  TOO_SOON_TO_REGISTER = 'TOO_SOON_TO_REGISTER',
}

@Injectable({
  providedIn: 'root',
})
export class IdentifyCustomerByAddressService {
  constructor(
    private http: HttpClient,
    private handshakeService: HandshakeService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {}

  findByDetails(details: { postcode: string; lastName: string; house: string }) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const apiURL = `${this.config.apigeeApi?.baseUrl}${this.config.compaxAngularApi.findCustomer}`;
        const { house: streetNumber, ...rest } = details;
        const findDetails = { streetNumber, ...rest };
        return this.http.post(apiURL, findDetails, authorizationHeaders).pipe(
          mergeMap((results: any) => {
            return of(results);
          })
        );
      }),
      catchError((error) => {
        return of({ error });
      })
    );
  }
}
